import { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import { logAnalyticsEvent } from "../engagement/Amplitude";
import { useShowTempErrorMessage } from "../shared/hooks/useUtilityContext";

const SignUpModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const setTempErrorMessage = useShowTempErrorMessage();

  const handleSignUp = async () => {
    try {
      const { data, error } = await supabase.auth.signUp({
        email: email,
        password: password,
      });

      if (error) {
        setError(error.message);
        throw error;
      }

      logAnalyticsEvent("Sign Up");
      console.log(data);
      onClose();
    } catch (error) {
      logAnalyticsEvent("Sign Up Error", {
        error: error,
      });
      let errorMessage = "Failed to sign up";
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      setTempErrorMessage(errorMessage);
      console.log(errorMessage, error);
    }
  };
  return (
    <div className={`modal ${isOpen ? "modal-open" : ""}`}>
      <div className="modal-box">
        <h3 className="font-bold text-lg">Sign Up</h3>
        <div className="form-control">
          <label className="label">
            <span className="label-text">Email</span>
          </label>
          <input
            type="email"
            placeholder="Enter your email"
            className="input input-bordered"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError(null);
            }}
          />
        </div>
        <div className="form-control">
          <label className="label">
            <span className="label-text">Password</span>
          </label>
          <input
            type="password"
            placeholder="Enter your password"
            className="input input-bordered"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {error && <div className="text-red-500 mt-4">{error}</div>}
        <div className="modal-action">
          <button
            className="btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSignUp}
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignUpModal;
